import TestScore from './TestScore';
import { PercentileScoreDTO, ScoreDTO } from '@/Models/CandidateOverview';
import { TestTypes } from '@/Models/Configuration';
import { TalentScore } from '@/Models/TalentScore';
import UIStrings from '@/Utils/UIStrings';

interface DialogCardTestInfoProps {
    aptitudeScore?: PercentileScoreDTO | null;
    emotionalIntelligenceScore?: PercentileScoreDTO | null;
    personalityScore?: PercentileScoreDTO | null;
    skillsScore?: PercentileScoreDTO | null;
    talentScore?: TalentScore | null;
    experienceCriteriaScore?: ScoreDTO | null;
    testTypes: Array<TestTypes>;
    includesExperienceCriteria: boolean;
}

function DialogCardTestInfo({
    aptitudeScore,
    emotionalIntelligenceScore,
    personalityScore,
    skillsScore,
    talentScore,
    experienceCriteriaScore,
    testTypes,
    includesExperienceCriteria,
}: DialogCardTestInfoProps) {
    return (
        <div className="flex flex-row pr-5 pl-6">
            <TestScore
                label={UIStrings.TalentScore}
                scoreLevel={talentScore?.scoreLevel}
                scoreValue={talentScore?.talentScore}
                talentScore
            />
            {includesExperienceCriteria && (
                <TestScore
                    label={UIStrings.Experience}
                    scoreLevel={experienceCriteriaScore?.scoreLevel}
                    scoreValue={experienceCriteriaScore?.score}
                />
            )}
            {testTypes.includes(TestTypes.Personality) && (
                <TestScore
                    label={UIStrings.Personality}
                    scoreLevel={personalityScore?.percentileLevel}
                    scoreValue={personalityScore?.percentileScore}
                />
            )}
            {testTypes.includes(TestTypes.Aptitude) && (
                <TestScore
                    label={UIStrings.Aptitude}
                    scoreLevel={aptitudeScore?.percentileLevel}
                    scoreValue={aptitudeScore?.percentileScore}
                />
            )}
            {testTypes.includes(TestTypes.Skills) && (
                <TestScore
                    label={UIStrings.Skills}
                    scoreLevel={skillsScore?.percentileLevel}
                    scoreValue={skillsScore?.percentileScore}
                />
            )}
            {testTypes.includes(TestTypes.EmotionalIntelligence) && (
                <TestScore
                    label={UIStrings.EmotionalIntelligence}
                    scoreLevel={emotionalIntelligenceScore?.percentileLevel}
                    scoreValue={emotionalIntelligenceScore?.percentileScore}
                />
            )}
        </div>
    );
}

export default DialogCardTestInfo;
